import React from "react";
import qs from "query-string";
import { getI18n, withI18n } from "react-i18next";
import styled from "styled-components";
import { connect } from "react-redux";
// @ts-ignore
import { GoogleReCaptchaProvider, withGoogleReCaptcha } from "react-google-recaptcha-v3";
// @ts-ignore
import { CWBDropdown, CWBCheckbox } from "@castingworkbook/cwb-react";
import {
  NameMaxLength,
  getSessionId,
  getCurUserSignUp,
  getCountryCode,
  setRegionCode,
  getWebSessionKey,
  errorPageRedirect,
} from "../../../helpers";
import BirthDatePicker from "../../Common/BirthDatePicker";
import Button from "../../Common/Button";
import Footer from "../../Common/Footer";
import Modal from "../../Common/Modal";
import PageContainer from "../../Common/PageContainer";
import Tooltip from "../../Common/Tooltip";
import Typography from "../../Common/Typography";
import {
  Section,
  SectionTitle,
  StyledInput,
  SmallTextError,
  Spinner,
  CheckboxWrapperStage,
  StyledCheckbox,
  LargeText,
  ErrorText,
} from "../../Common/StyledComponents";
import CWBLabsActorStageNameStep from "components/CWBLabs/ActorStageNameStep";
import { BlendedStyledInput } from "components/Common";
import {
  IActorStageName,
  IActorError,
  IActorFilmCenter,
} from "../../../shared/api/dtos/IActorDto";
import { iRootState } from "../../../store";
import { nameRegex } from "helpers/validations";
// @ts-ignore
import * as Sentry from "@sentry/react";
import { IGroupedCountry } from "helpers/ICountryList";
import * as ActorJobsApi from "../../../shared/api/ActorJobs.api";
// @ts-ignore
import moment from "moment";
import { ISignupAccountDto, ISignupResidence } from "shared/api/dtos/ISignupDto";
import ResidenceModal from "components/Modals/residenceModal";
import { AxiosResponse } from "axios";

interface IProps extends StateProps, DispatchProps {
  t?: any;
  history?: any;
  location?: any;
  googleReCaptchaProps?: any; // Injected by withGoogleReCaptcha
}

interface IState {
  fields: any;
  isFormSubmitClicked: boolean;
  ageChecked: boolean;

  cityList: any[];
  residenceModalOpen: boolean;
  residenceChecking: boolean;

  isStageNameChanged: boolean;
  isResidenceChanged: boolean;

  isFreeToSubmit?: boolean;
  isInvitation?: boolean;
  recaptchaToken?: string;
}

class ActorStageNameStep extends React.Component<IProps, IState> {
  public state: IState = {
    fields: {
      firstName: "",
      lastName: "",
      middleName: "",
      birthDate: null,

      country: "",
      province: "",
      provinceId: 1,
      city: "",
      cityId: 1,
      countryId: 1,
      sendBreakdowns: true,
      representedActor: false,
      unionActor: false,
      memberId: "",
      onCamera: true,
      voice: true,
      information: ""
    },
    isFormSubmitClicked: false,
    ageChecked: false,
    cityList: [],

    isStageNameChanged: false,
    isResidenceChanged: false,

    residenceModalOpen: false,
    residenceChecking: false,

    isFreeToSubmit: false,
    recaptchaToken: "",
    isInvitation: false,
  };

  async componentDidMount() {
    const user: ISignupAccountDto = getCurUserSignUp();
    const { location } = this.props;
    const qsArgs = qs.parse(location.search);

    if (qsArgs.ac === 'true') {
      this.setState({ isInvitation: true });
    }

    if (getSessionId() && user) {
      if (this.props.groupCountryList.length <= 0)
        if (this.props.groupCountryList.length <= 0)
          await this.props.getGroupCountryList();

      if (user.signupResidence) this.mapUserToStateFields(user.signupResidence);
      else {
        try {
          const grpCountries = this.props.groupCountryList;
          let country = grpCountries[0];

          let countryCode = getCountryCode()?.toUpperCase();
          if (!countryCode || countryCode == "") countryCode = "CA";

          country = grpCountries.find(
            (x) => x.country.countryCode?.toUpperCase() === countryCode
          );

          this.setCountry(country);

          const regionCode =
            country!.country!.locationCode || country!.country!.countryCode;
          setRegionCode(regionCode);
        } catch (error) {
          await this.props.getGroupCountryList();
        }
      }

      if (user.signupDetails) {
        let fields = this.state.fields;

        fields.firstName = user.signupDetails.firstName;
        fields.middleName = user.signupDetails.middleName;
        fields.lastName = user.signupDetails.lastName;

        if (user.signupDetails.birthDate) {
          const date = new Date(
            user.signupDetails.birthDate
          );

          if (!isNaN(date.getTime())) {
            fields.birthDate = new Date(
              date
            ).toISOString().split('T')[0];
          }
        }

        this.setState({ fields });
      }


      const additionalInfo: any = user.signupResidence && user.signupDetails
        ? { ...user.signupDetails, ...user.signupResidence }
        : user.signupResidence || user.signupDetails;

      if (additionalInfo) {
        let fields = this.state.fields;

        fields.country = additionalInfo.country;
        fields.province = additionalInfo.province;
        fields.provinceId = additionalInfo.provinceId;
        fields.city = additionalInfo.city;
        fields.cityId = additionalInfo.cityId;
        fields.countryId = additionalInfo.countryId;
        fields.sendBreakdowns = additionalInfo.sendBreakdowns;
        fields.representedActor = additionalInfo.representedActor;
        fields.unionActor = additionalInfo.unionActor;
        fields.memberId = additionalInfo.memberId;
        fields.onCamera = additionalInfo.onCamera;
        fields.voice = additionalInfo.voice;
        this.setState({ fields });
      }
      this.props.setIsLoading(false);
    } else {
      window.location.replace("/");
    }
  }

  checkValidationStageName() {
    const { t } = this.props;
    let fields: IActorStageName & IActorFilmCenter = this.state.fields;
    let errors: IActorError = {} as IActorError;

    if (!fields.firstName) {
      errors.FirstName = t("First Name is required");
    } else if (fields.firstName.trim().length < 2) {
      errors.FirstName = t("Minimum 2 characters");
    } else if (!nameRegex.test(fields.firstName)) {
      errors.FirstName = t(
        "Name can only contain letters, spaces, -, ' and `."
      );
    }

    if (!fields.lastName) {
      errors.LastName = t("Last Name is required");
    } else if (fields.lastName.trim().length < 2) {
      errors.LastName = t("Minimum 2 characters");
    } else if (!nameRegex.test(fields.lastName)) {
      errors.LastName = t(
        "Name can only contain letters, spaces, -, ' and `."
      );
    }

    return errors;
  }

  checkValidationResidence() {
    const { t } = this.props;
    let fields: IActorStageName & IActorFilmCenter = this.state.fields;
    let errors: IActorError = {} as IActorError;

    if (!this.state.ageChecked) {
      errors.ageChecked = t("This field is mandatory");
    }

    //country
    if (!fields.country) errors.Country = t("Country field is required");

    //city
    if (!fields.city) errors.City = t("City field is required");

    if (fields.unionActor) {
      if (!fields.memberId) {
        errors.MemberId = t("Membership ID is required");
      } else {
        if (!fields.memberId.match(/^[0-9 \.\-`]+$/i)) {
          errors.MemberId = t("Only numbers are accepted");
        }

        if (fields.memberId.length < 6) {
          errors.MemberId = t("Membership ID is invalid");
        }
      }
    }

    return errors;
  }

  checkValidation() {
    const stageNameErrors = this.checkValidationStageName();
    const residenceErrors = this.checkValidationResidence();

    const errors = {
      ...stageNameErrors,
      ...residenceErrors,
    };

    this.props.setErrors(errors);
    return Object.entries(errors).length === 0 && errors.constructor === Object;
  }

  handleChange = (e: any) => {
    const isStageNameChanged = [
      "firstName", "lastName", "middleName", "birthDate",
    ].some(fieldName => fieldName === e.target.name);
    const isResidenceChanged = [
      "country", "province", "provinceId", "city", "cityId",
      "countryId", "sendBreakdowns", "representedActor",
      "unionActor", "memberId", "onCamera", "voice",
    ].some(fieldName => fieldName === e.target.name);

    this.setState(
      {
        fields: {
          ...this.state.fields,
          [e.target.name]: e.target.value,
        },
        isStageNameChanged,
        isResidenceChanged,
      },
      () => {
        this.state.isFormSubmitClicked && this.checkValidation();
      }
    );
  };

  handleBlur = async () => {
    // TODO

    // We want this to happen when the user deselects a field
    // If Stage Name or Residence are filled submit on change
    if (
      this.state.isStageNameChanged
      && Object.keys(this.checkValidationStageName()).length === 0
    ) {
      await this.createStageName({ isLoadingDisabled: true, recaptchaToken: this.state.recaptchaToken });
      this.setState({
        isStageNameChanged: false,
      });
    }

    // if (
    //   this.state.isResidenceChanged
    //   && Object.keys(this.checkValidationResidence()).length === 0
    // ) {
    //   await this.createActorResidence();
    //   resetFlags.isResidenceChanged = false;
    // }
  }

  handleAgeCheck = (e: any) => {
    this.setState(
      {
        ageChecked: !this.state.ageChecked,
      },
      () => {
        this.state.isFormSubmitClicked && this.checkValidation();
      }
    );
  };

  createNameAndResidence = async (e: any) => {
    e.preventDefault();
    this.setState({ isFormSubmitClicked: true });
    if (!this.checkValidation()) return;

    if (!this.props.googleReCaptchaProps) {
      // console.error("reCAPTCHA not available");
      // Optionally, set an error message for the user
      this.props.history.push({
        pathname: "/failConfirm?reason=recaptcha_not_available"
      });
      return;
    }

    const recaptchaToken = await this.props.googleReCaptchaProps.executeRecaptcha('signup');
    this.setState({ recaptchaToken: recaptchaToken });

    const { location } = this.props;
    const qsArgs = qs.parse(location.search);
    if (
      qsArgs.bd &&
      (qsArgs.page === "openbd" ||
        qsArgs.page === "submission")
    ) {
      this.setState({
        residenceChecking: true,
      });

      await this.checkResidenceArea(recaptchaToken);
    } else {
      await this.continueSaveup(recaptchaToken);
    }
  }

  checkResidenceArea = async (recaptchaToken: string) => {
    const { location } = this.props;
    const { fields } = this.state;
    const { cityId } = fields;
    const bdId = qs.parse(location.search).bd;
    const sessionId = getSessionId();
    const page = qs.parse(location.search).page as string;
    try {
      const filterResponse = await ActorJobsApi.getFilterResult(
        sessionId,
        bdId,
        cityId,
        page
      );
      if (
        filterResponse.status === 200 &&
        filterResponse.data &&
        filterResponse.data.countryMismatch
      ) {
        this.setState({
          residenceModalOpen: true,
          residenceChecking: false,
          isFreeToSubmit: filterResponse.data.isFreeToSubmit
        });
      } else {
        this.setState({
          residenceChecking: false,
          isFreeToSubmit: filterResponse.data?.isFreeToSubmit
        });
        await this.continueSaveup(recaptchaToken, filterResponse.data?.isFreeToSubmit);
      }
    } catch (err) {
      this.setState({
        residenceChecking: false,
      });
      await this.continueSaveup(recaptchaToken, false);
    }
  };

  continueSaveup = async (recaptchaToken: string, direct?: boolean) => {
    const stageNameSuccess = await this.createStageName({ recaptchaToken });
    const residenceSuccess = await this.createActorResidence({ recaptchaToken });
    if (stageNameSuccess === false || residenceSuccess === false) {
      this.props.setIsLoading(false);
      if (this.checkValidation()) {
        // unknown error occurred
        errorPageRedirect();
        return;
      } else {
        // errors being displayed
        return;
      }
    }

    const response = await this.createActorAccountPartial({
      recaptchaToken: recaptchaToken,
      direct: direct,
      information: this.state.fields.information,
    });

    this.props.setIsLoading(true);
    if (direct) {
      this.moveToLiteComplete();
    } else {
      const { location } = this.props;
      if (qs.parse(location.search).offer) {
        this.moveToNextOffer();
      } else {
        this.moveToNext(response?.data.sessionId);
      }
    }
  };

  createStageName = async (options?: { isLoadingDisabled?: boolean, recaptchaToken: string }): Promise<boolean> => {
    let birthDateString = null;
    try {
      birthDateString = this.state.fields.birthDate.toISOString();
    } catch (e) {
      try {
        birthDateString = moment(this.state.fields.birthDate).toISOString(true);
      } catch (e2) {
        birthDateString = null;
      }
    }

    try {
      const dto = {
        ...this.state.fields,
        birthDate: birthDateString,
        recaptchaToken: options?.recaptchaToken,
      }
      if (options && 'isLoadingDisabled' in options) {
        dto.isLoadingDisabled = options.isLoadingDisabled;
      }
      const result = await this.props.createStageName(dto);
      return result;
    } catch (e) {
      Sentry.captureException(e);
      return false;
    }
  };

  createActorResidence = async (options?: { recaptchaToken?: string }): Promise<boolean> => {
    try {
      return await this.props.createActorResidence({ ...options, ...this.state.fields });
    } catch (e) {
      Sentry.captureException(e);
      return false;
    }
  }

  createActorAccountPartial = async (options: { recaptchaToken: string, direct?: boolean, information?: string }): Promise<any> => {
    try {
      await this.props.createActorAccountPartial({ recaptchaToken: options.recaptchaToken, direct: options.direct, information: options.information });
    } catch (e) {
      Sentry.captureException(e);
    }
  }

  moveToNext = (sessionId: string) => {
    if (this.props.errors.errorMessage)
      errorPageRedirect();
    else if (
      !this.props.errors
      || (
        Object.entries(this.props.errors).length === 0
        && this.props.errors.constructor === Object
      )
    ) {
      const customQs = qs.parse(this.props.location.search);

      const sessionId = getSessionId();
      if (sessionId) {
        customQs.sessionId = sessionId;
      }

      customQs.k = getWebSessionKey();
      const qsText = qs.stringify(customQs);

      if (this.state.isInvitation) {
        if (!customQs.ag || customQs.ag === 'undefined') {
          console.error('Agent ID missing');
          return;
        }
        window.location.href = `${process.env.REACT_APP_CWB_Signup_Base}/onboarding?${qsText}`;
      } else {
        window.location.href = `${process.env.REACT_APP_CWB_Membership_Base}/promo?${qsText}`;
      }
    }
  };

  moveToNextOffer = () => {
    if (this.props.errors.errorMessage)
      errorPageRedirect();
    else if (
      !this.props.errors ||
      (Object.entries(this.props.errors).length === 0 &&
        this.props.errors.constructor === Object)
    ) {
      this.props.history.push({
        pathname: "/actor/offer/4",
        search: this.props.location.search,
      });
    }
  };


  moveToLiteComplete = () => {
    if (this.props.errors.errorMessage)
      errorPageRedirect();
    else if (
      !this.props.errors ||
      (Object.entries(this.props.errors).length === 0 &&
        this.props.errors.constructor === Object)
    ) {

      const sessionId = getSessionId();
      const params = qs.stringify({
        sessionId: sessionId,
        ...(qs.parse(this.props.location.search))
      });

      this.props.history.push(`/actor/free-completed?${params}`);
    }
  };

  moveToTrialCheckout = () => {
    if (this.props.errors.errorMessage)
      errorPageRedirect();
    else if (
      !this.props.errors ||
      (Object.entries(this.props.errors).length === 0 &&
        this.props.errors.constructor === Object)
    ) {
      this.props.history.push({
        pathname: "/actor/free-trial/completed",
        search: this.props.location.search,
      });
    }
  };

  getCountry = (): IGroupedCountry => {
    const fields: IActorFilmCenter = this.state.fields;
    let country = this.props.groupCountryList.find(
      (x) => x.id === fields.countryId
    );

    if (fields.province && fields.country) return country;

    const qsArgs = qs.parse(this.props.location.search);
    let countryCode = getCountryCode();
    if (countryCode)
      country = this.props.groupCountryList.find(
        (x) => x.value === countryCode || x.value?.toUpperCase() == countryCode.toUpperCase()
      );
    else if (qsArgs.ctry)
      country = this.props.groupCountryList.find(
        (x) => x.value === qsArgs.ctry || x.value?.toUpperCase() == qsArgs.ctry.toString().toUpperCase()
      );

    return country;
  };

  handleCountry = (option: any) => {
    let fields: IActorFilmCenter = this.state.fields;
    fields.city = '';
    fields.cityId = 1;

    fields.country = option.value;
    fields.countryId = option.id;
    fields.provinceId = option.country!.provinceId;
    fields.province = option.country!.provinceName;
    this.setState({ fields });
    this.setCountry(option);

    const regionCode =
      option!.country!.locationCode || option!.country!.countryCode;
    setRegionCode(regionCode);

    this.state.isFormSubmitClicked && this.checkValidation();
  };

  setCityList = (list: any) => {
    const cityList = list
      ? list.map((city: any) => ({
        label: city.cityName,
        value: city.cityName,
        id: city.cityId,
        city,
      }))
      : [];

    this.setState({
      cityList,
    });
  }

  setCountry = (option: any) => {
    let fields: IActorFilmCenter = this.state.fields;
    try {
      fields.country = option.value;
      fields.countryId = option.id;

      if (option.cityList) {
        this.setCityList(option.cityList);
      }

      this.setState({
        fields,
        isResidenceChanged: true,
      });
    } catch (err) {
      // nothing needed here... an unhandled error sometimes occurs if the country.cities are not loaded yet and the user click the city dropdown
    }
  };

  handleCity = (option: any) => {
    let fields: IActorFilmCenter = this.state.fields;
    fields.city = option.value;
    fields.cityId = option.id;
    fields.provinceId = option.city!.provinceId;
    fields.province = option.city!.provinceName;
    this.setState({
      fields,
      isResidenceChanged: true,
    }, async () => {
      // Silent auto-save if country and city are filled and valid
      if (this.state.fields.country && this.state.fields.city) {
        const hasLocationErrors = this.props.errors?.Country || this.props.errors?.City;

        if (!hasLocationErrors) {
          try {
            const success = await this.createActorResidence();
            if (success) {
              this.setState({ isResidenceChanged: false });
            }
          } catch (e) {
            // Silent error - no UI feedback
          }
        }
      }
    });
    this.state.isFormSubmitClicked && this.checkValidation();
  };

  handleSendBreakdowns = (newChoice: any) => {
    let fields: IActorFilmCenter = { ...this.state.fields };
    fields.sendBreakdowns = newChoice;
    this.setState({ fields });
  };

  handleRepresentedActor = (newChoice: any) => {
    let fields: IActorFilmCenter = { ...this.state.fields };
    fields.representedActor = newChoice;
    this.setState({ fields });
  };

  handleUnionActor = (newChoice: any) => {
    let fields: IActorFilmCenter = { ...this.state.fields };
    fields.unionActor = newChoice;
    if (!fields.unionActor) {
      fields.memberId = '';
    }
    this.setState({ fields });
  };

  mapUserToStateFields = (userfilmCenter: ISignupResidence) => {
    if (!userfilmCenter) return;
    let fields: ISignupResidence = this.state.fields;

    fields.province = userfilmCenter.province;
    fields.provinceId = userfilmCenter.provinceId;
    fields.city = userfilmCenter.city;
    fields.cityId = userfilmCenter.cityId;
    fields.countryId = userfilmCenter.countryId;
    fields.onCamera = userfilmCenter ? userfilmCenter.onCamera : false;
    fields.voice = userfilmCenter ? userfilmCenter.voice : false;
    fields.sendBreakdowns = userfilmCenter ? userfilmCenter.sendBreakdowns : false;

    fields.representedActor = userfilmCenter ? userfilmCenter.representedActor : false;
    fields.unionActor = userfilmCenter ? userfilmCenter.unionActor : false;
    fields.memberId = userfilmCenter.memberId;

    this.setState({ fields });

    const grpCountries = this.props.groupCountryList;

    if (fields.countryId) {
      const country = grpCountries.find((x) => x.id === fields.countryId);
      this.setCountry(country);

      const regionCode =
        country!.country!.locationCode || country!.country!.countryCode;
      setRegionCode(regionCode);
    } else {
      const altCountry = this.getCountry();
      if (altCountry) {
        this.setCountry(altCountry);

        const regionCode =
          altCountry!.country!.locationCode || altCountry!.country!.countryCode;
        setRegionCode(regionCode);
      }
    }
  };

  render() {
    const { t, location } = this.props;
    const errors = this.props.errors;
    const fields = this.state.fields;
    const ageChecked = this.state.ageChecked;

    const hoverTip = (
      <StyledTooltip
        placement="top"
        tip={t(
          "This field is not mandatory. Some projects require youth and young adults to qualify for project eligibility by being at least a certain age."
        )}
      >
        <img alt="more info" src="../images/info.svg" />
      </StyledTooltip>
    );

    const isLangSpanish = getI18n().language === "es";
    // const special = qs.parse(location.search).special;
    const special = false;

    // Film center
    const country = this.getCountry();
    const city = this.state.cityList.find((x) => x.id === fields.cityId);

    const toHomePage = () => {
      const bdId = qs.parse(location.search).bd;
      if (bdId) {
        window.location.href = `${process.env.REACT_APP_CWB_Site}/open-breakdown.asp?bd=${bdId}`;
      } else {
        window.location.href = `${process.env.REACT_APP_CWB_Site}`;
      }
    };

    return (
      <PageContainer>
        <Wrapper>
          <StyledTypography align="center" component="h1" variant="h2">
            {t("Profile Information")}
          </StyledTypography>
          <StyledForm onSubmit={this.createNameAndResidence} onBlur={this.handleBlur}>
            <Typography color="darkGrey" component="h2" variant="h5">
              {special
                ? t("Tell us your stage name for casting")
                : t("What's your stage name?")}
            </Typography>
            <Section>
              <SectionTitle>{t("First Name")}</SectionTitle>
              <StyledInput
                name="firstName"
                type="text"
                className={errors.FirstName ? "invalid" : ""}
                maxLength={NameMaxLength}
                onChange={this.handleChange}
                value={fields.firstName}
              />
              <SmallTextError className="error">
                <span>{errors.FirstName}</span>
              </SmallTextError>
            </Section>
            {/* {!isLangSpanish && (
              <Section>
                <SectionTitle>
                  {t("Middle Name (If used professionally)")}
                </SectionTitle>
                <StyledInput
                  name="middleName"
                  type="text"
                  className={errors.MiddleName ? "invalid" : ""}
                  maxLength={NameMaxLength}
                  onChange={this.handleChange}
                  value={fields.middleName}
                />
                <SmallTextError className="error">
                  <span>{errors.MiddleName}</span>
                </SmallTextError>
              </Section>
            )} */}
            <Section>
              <SectionTitle>{t("Last Name")}</SectionTitle>
              <StyledInput
                type="text"
                name="lastName"
                maxLength={NameMaxLength}
                className={errors.LastName ? "invalid" : ""}
                onChange={this.handleChange}
                value={fields.lastName}
              />
              <SmallTextError className="error">
                <span>{errors.LastName}</span>
              </SmallTextError>
            </Section>
            <StyledH2 color="darkGrey" component="h2" variant="h5">
              {t("When's your birthday?")}
              {hoverTip}
            </StyledH2>
            <Section>
              <BirthDatePicker
                name="birthDate"
                value={fields.birthDate}
                onChange={this.handleChange}
              />
            </Section>
            <Section>
              <CheckboxWrapperStage onClick={this.handleAgeCheck}>
                <AgeCheckbox className="small-cb" isChecked={ageChecked} />
                <StyledLabel>
                  {t(
                    "I am currently at least 18 years old or this is being filled by a parent or guardian"
                  )}
                </StyledLabel>
              </CheckboxWrapperStage>
              <SmallTextError className="error">
                <span>{errors.ageChecked}</span>
              </SmallTextError>
            </Section>

            <Section className="margin-bottom-none">
              <LargeText>{t("Film center")}</LargeText>
            </Section>
            <Section className="">
              <SectionTitle>{t("Choose your country")}</SectionTitle>
              <CWBDropdown
                value={country}
                isValueSelected={true}
                placeholder={t("Select Country")}
                items={this.props.groupCountryList}
                onChange={this.handleCountry}
                className={errors.Country ? "validationError" : ''}
              />
              <ErrorText>{t(errors.Country) || errors.Country}</ErrorText>
            </Section>
            <Section className="margin-bottom-none">
              <SectionTitle>{t("Choose your nearest city")}</SectionTitle>
              <CWBDropdown
                value={city || null}
                isValueSelected={true}
                placeholder={t("Select an Option")}
                items={this.state.cityList ? this.state.cityList : []}
                onChange={this.handleCity}
                className={errors.City ? "validationError" : ''}
              />
              <ErrorText>{t(errors.City) || errors.City}</ErrorText>
            </Section>
            <Section className="margin-bottom-none prevent" aria-hidden="true">
              <SectionTitle>{t("CustomCaptureInformation")}</SectionTitle>
              <StyledInput
                type="text"
                name="information"
                maxLength={NameMaxLength}
                className={"prevent " + (errors.Information ? "invalid" : "")}
                onChange={this.handleChange}
                value={fields.information}
                tabIndex={-1}
                autoComplete="new-password"
                autoCorrect="off"
                autoCapitalize="off"
                aria-label="Please leave this field empty"
                aria-hidden="true"
                data-form-type="other"
              />
              <ErrorText>{t(errors.Information) || errors.Information}</ErrorText>
            </Section>

            <Section className="margin-top-none">
              {this.state.isInvitation ? null : <div onClick={() => this.handleSendBreakdowns(!fields.sendBreakdowns)}>
                <InlineCheckbox isChecked={fields.sendBreakdowns} id="breakdowns-check" />
                <StyledCustomLabel htmlFor="breakdowns-check">{t("Send me breakdowns for my city")}</StyledCustomLabel>
              </div>}
              {(country?.id === 2 || country?.id == 18) && !this.state.isInvitation ?
                (
                  <div onClick={() => this.handleRepresentedActor(!fields.representedActor)}>
                    <InlineCheckbox isChecked={fields.representedActor} id="representedActor-check" />
                    <StyledCustomLabel htmlFor="representedActor-check">{t("I'm a represented actor")}</StyledCustomLabel>
                  </div>
                ) : (<></>)}

              {country?.id === 2 && !this.state.isInvitation ?
                (<>
                  <div onClick={() => this.handleUnionActor(!fields.unionActor)}>
                    <InlineCheckbox isChecked={fields.unionActor} id="unionActor-check" />
                    <StyledCustomLabel htmlFor="unionActor-check">{t("I'm a US SAG-AFTRA member")}</StyledCustomLabel>
                  </div>

                  {fields.unionActor ?
                    (<div style={{ marginRight: "25px" }}>
                      <SectionTitle>{t("SAG-AFTRA member ID")}</SectionTitle>
                      <BlendedStyledInput style={{ marginTop: "8px", maxWidth: "290px" }}
                        error={Boolean(errors.MemberId)}
                        errorMessage={t(errors.MemberId) || errors.MemberId}
                        name="memberId"
                        maxLength="12"
                        value={fields.memberId}
                        onChange={this.handleChange}
                      />
                    </div>) : <></>
                  }
                </>
                ) : (<></>)
              }
            </Section>
            <Section>
              <StyledButton disabled={this.props.isLoading || this.state.residenceChecking}>
                {this.state.isInvitation ? t("Continue") : t("Create")}
                {((!this.state.residenceModalOpen && this.props.isLoading)
                  || this.state.residenceChecking)
                  && (
                    <Spinner
                      src="../images/spinner.svg"
                      className="spinner-width"
                    />
                  )
                }
              </StyledButton>
            </Section>
          </StyledForm>
        </Wrapper>
        <Footer />
        {this.state.residenceModalOpen && (
          <ResidenceModal
            onClose={() =>
              this.setState({
                residenceModalOpen: false,
              })
            }
            handleUpgrade={() => this.continueSaveup(this.state.recaptchaToken, this.state.isFreeToSubmit)}
            toHomePage={toHomePage}
          />
        )}
      </PageContainer>
    );
  }
}

const Wrapper = styled(Modal)`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  font-weight: ${(p) => p.theme["font-weight-600"]};

  width: 480px;
  width: 480px;
  background-color: ${(p) => p.theme.white};
  padding: 40px 80px 50px;

  @media all and (max-width: 520px) {
    width: 100%;
    min-width: 40%;
    padding: 40px;
  }

  & input {
    font-size: ${(p) => p.theme["s-font-size"]};
  }

  .cwb-dropdown-wrapper {
    margin-top: 8px;
    max-width: 100%;
    height: 40px;

    .cwb-dropdown__single-value {
      font-size: ${(p) => p.theme["xs-font-size"]};
    }

    .cwb-dropdown__indicator {
      width: 14px;
    }
  }

  .cwb-dropdown__placeholder {
    color: ${(p) => p.theme.midGrey};
    font-size: ${(p) => p.theme["xs-font-size"]};
    font-weight: ${(p) => p.theme["font-weight-600"]};
  }

  .cwb-dropdown-wrapper > div {
    min-width: 100%;
    max-width: 100%;
  }

  .cwb-dropdown-wrapper .validationError {
    .cwb-dropdown__control {
      border-color: ${(p) => p.theme.errorColor} !important;
    }
    .cwb-dropdown__placeholder {
      color: ${(p) => p.theme.errorColor} !important;
    }
  }

  .cwb-dropdown-wrapper > div .cwb-dropdown__control {
    min-height: 40px;
    border: ${(props) => props.theme.dropDown["border"]} !important;
    border-radius: ${(props) => props.theme.dropDown["border-radius"]};
  }

  .prevent {
    position: absolute;
    left: -5000px;
    text-indent: 100%;
    white-space: nowrap;
    overflow: hidden;
  }

`;

const StyledTypography = styled(Typography)`
  margin-bottom: ${(p) => p.theme.spacing(3)};
`;

const StyledForm = styled.form`
  width: 100%;
`;

const StyledTooltip = styled(Tooltip)`
  margin-left: 5px;

  & > img {
    width: 18px;
    height: 18px;
    margin-top: -2px;
  }
`;

const StyledButton = styled(Button)`
  width: 100%;
  height: 37px;
  font-size: 13px;
  font-weight: 600;
  background-color: ${(p) => p.theme.palette.brand.lightBlue};

  &:hover {
    background-color: ${(p) => p.theme.palette.brand.blue};
  }

  &:active {
    background-color: ${(p) => p.theme.palette.brand.darkBlue};
  }
  &:disabled {
    pointer-events: none;
  }
`;

const StyledH2 = styled(Typography)`
  margin-top: ${(p) => p.theme.spacing(3)};
`;

const StyledLabel = styled(Typography)`
  margin-left: ${(p) => p.theme.spacing(1)};
  font-size: ${(p) => p.theme["xxs-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  color: ${(p) => p.theme.color} !important;
  line-height: 16px;
  cursor: pointer;
`;

const AgeCheckbox = styled(StyledCheckbox)`
  cursor: pointer;
`;

const InlineCheckbox = styled(CWBCheckbox)`
  display:inline-block;
`;

const StyledCustomLabel = styled.label`
  font-size: ${(p) => p.theme["xs-font-size"]};
  letter-spacing: 0.2px;
  margin-left: 16px;
  cursor: pointer;
`;

interface StateProps {
  errors: IActorError;
  isLoading: boolean;
  groupCountryList: IGroupedCountry[];
}

function mapStateToProps(state: iRootState): StateProps {
  return {
    errors: state.actorModel.errors,
    isLoading: state.actorModel.isLoading,

    groupCountryList: state.referencesModel.supportedGroupCountryList,
  };
}

interface DispatchProps {
  setErrors: (errors: IActorError) => void;
  createStageName: (dto: IActorStageName & { recaptchaToken?: string, isLoadingDisabled?: boolean }) => Promise<boolean>;
  setClientId: (clientId: string) => void;
  setIsLoading: (status: boolean) => void;
  createActorResidence: (dto: ISignupResidence & { recaptchaToken?: string }) => Promise<boolean>;
  createActorAccountPartial: (options: { recaptchaToken?: string, direct?: boolean, information?: string }) => any;

  getGroupCountryList: () => void;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    setErrors: dispatch.actorModel.setErrors,
    createStageName: dispatch.actorModel.createStageName,
    setClientId: dispatch.actorModel.setClientId,
    setIsLoading: dispatch.actorModel.setIsLoading,
    createActorResidence: dispatch.actorModel.createActorResidence,
    createActorAccountPartial: dispatch.actorModel.createActorAccountPartial,

    getGroupCountryList: dispatch.referencesModel.getSupportedGroupCountryList,
  };
}

const ActorStageNameStepWithRecaptcha = withGoogleReCaptcha(ActorStageNameStep);

export default withI18n()(
  connect(mapStateToProps, mapDispatchToProps)(
    (props: IProps) => ( // Wrapper component to provide GoogleReCaptchaProvider
      <GoogleReCaptchaProvider
        reCaptchaKey={"6LdWFmErAAAAAOxDkqsoYOctVzzvnCsbvj-kqZNi"}
      >
        <ActorStageNameStepWithRecaptcha {...props} />
      </GoogleReCaptchaProvider>
    )
  )
);
